export const setKeyCloak = (keycloak) => {
  localStorage.setItem('token', keycloak.token);
};
